export default {"src":"/_next/static/media/Apple_Pay_Mark.f5254008.svg","height":106,"width":166,"blurWidth":0,"blurHeight":0};